const fn = {
    init: () => {
        if ($('[data-toggle="tooltip"]').length) {
            $('[data-toggle="tooltip"]').tooltip();
        }
    }
}

export default {
    can: () => $('[data-toggle="tooltip"]').length,
    run: fn.init,
};
